module.exports = __webpack_public_path__ + "img/alert.d81c46f9.svg";